const SkeletonBlock = ({ className = "" }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
);

const PageSkeleton = () => (
  <div className="w-full max-w-5xl mx-auto px-4 py-8 space-y-6">
    {/* Header */}
    <div className="space-y-3">
      <SkeletonBlock className="h-10 w-3/5" />
      <SkeletonBlock className="h-4 w-2/5" />
    </div>
    {/* Hero image */}
    <SkeletonBlock className="h-56 sm:h-72 w-full rounded-xl" />
    {/* Content blocks */}
    <div className="space-y-3">
      <SkeletonBlock className="h-4 w-full" />
      <SkeletonBlock className="h-4 w-full" />
      <SkeletonBlock className="h-4 w-4/5" />
    </div>
    {/* Cards row */}
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4">
      {[0, 1, 2].map((i) => (
        <div key={i} className="space-y-3 p-4 border border-gray-100 rounded-xl">
          <SkeletonBlock className="h-32 w-full rounded-lg" />
          <SkeletonBlock className="h-4 w-3/4" />
          <SkeletonBlock className="h-3 w-1/2" />
        </div>
      ))}
    </div>
    {/* More text */}
    <div className="space-y-3 pt-4">
      <SkeletonBlock className="h-4 w-full" />
      <SkeletonBlock className="h-4 w-5/6" />
      <SkeletonBlock className="h-4 w-3/4" />
    </div>
  </div>
);

const CardSkeleton = () => (
  <div className="w-full max-w-sm p-4 border border-gray-100 rounded-xl space-y-3">
    <SkeletonBlock className="h-40 w-full rounded-lg" />
    <SkeletonBlock className="h-5 w-3/4" />
    <SkeletonBlock className="h-3 w-full" />
    <SkeletonBlock className="h-3 w-5/6" />
    <SkeletonBlock className="h-8 w-24 rounded-full mt-2" />
  </div>
);

const TextSkeleton = ({ lines = 4 }) => (
  <div className="w-full space-y-3">
    {Array.from({ length: lines }).map((_, i) => (
      <SkeletonBlock
        key={i}
        className={`h-4 ${i === lines - 1 ? "w-3/5" : "w-full"}`}
      />
    ))}
  </div>
);

const SkeletonLoader = ({ variant = "page", lines }) => {
  switch (variant) {
    case "card":
      return <CardSkeleton />;
    case "text":
      return <TextSkeleton lines={lines} />;
    case "page":
    default:
      return <PageSkeleton />;
  }
};

export { PageSkeleton, CardSkeleton, TextSkeleton };
export default SkeletonLoader;
